import React from 'react';
import { Button, ButtonType } from "components/common/Button.component";
import { PencilIcon, Trash2Icon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const EditDeleteButtons = (props) => {

    return (
        <div className={"d-flex gap-8 py-3 align-self-center"}>
            <Button type={ButtonType.GHOST}
                    iconOnly={true}
                    icon={<PencilIcon size={ICON_SIZE.MEDIUM}/>}
                    onClick={props.editCallback}
                    disabled={props.disabled}
                    title={props.translate("workflows.edit")}
            />
            <Button type={ButtonType.GHOST}
                    iconOnly={true}
                    icon={<Trash2Icon size={ICON_SIZE.MEDIUM}/>}
                    onClick={props.deleteCallback}
                    disabled={props.disabled}
                    title={props.translate("workflows.delete")}
            />
        </div>
    )
};

export const SaveCancelButtons = (props) => {

    return (
        <div className={"d-flex gap-8 py-3 align-self-center"}>
            <Button type={ButtonType.SECONDARY}
                    onClick={props.saveCallback}
                    disabled={props.saveDisabled}
                    text={props.translate("workflowDetails.save")}
            />
            <Button type={ButtonType.SECONDARY}
                    onClick={props.cancelCallback}
                    text={props.translate("roles.cancel")}
            />
        </div>
    )
};